import angular from 'angular';
import { isNil, kebabCase } from 'lodash';

module.exports = angular.module('common.filters.kebabcase', [])
  .filter('kebabcase', function () {
    return function (value) {
      if (!isNil(value))
        return kebabCase(String(value));
    };
  })
  .name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/kebabcase.js
 **/